import React from 'react';
import { GenericDetailsView } from '../modules/myPrivileges/components/GenericDetailsView';
import { CardView } from '../modules/myPrivileges/components/GenericCardView';

export interface CardViewRegistry {
  cardViewComponent: CardView;
  detailsViewComponent: GenericDetailsView;
  cardViewId: string;
  isLocked: boolean;
  reducerSubName?: string;
  detailClass?: string;
}

export class MyPrivilegesCardViewRegistry {
  private cardViewRegistries: { [cardViewId: string]: CardViewRegistry } = {};

  register(
    cardViewId: string,
    cardViewComponent: any,
    detailsViewComponent: any,
    isLocked: boolean,
    reducerSubName?: string,
    detailClass?: string,
  ) {
    this.cardViewRegistries[cardViewId] = {
      cardViewComponent,
      detailsViewComponent,
      cardViewId,
      isLocked,
      reducerSubName,
      detailClass,
    };
  }

  get(): { [moduleName: string]: CardViewRegistry } {
    return this.cardViewRegistries;
  }

  renderCardView(cardViewIds: Array<string>) {
    const registries = this.get();
    const filterRegistries: { [cardViewId: string]: CardViewRegistry } = {};
    Object.values(cardViewIds).forEach((v) => {
      if (registries[v]) {
        filterRegistries[v] = registries[v];
      }
    });

    // $FlowIssue
    const results = [];
    for (const key in filterRegistries) {
      const c = filterRegistries[key];
      const CardViewComponent: any = c.cardViewComponent;
      if (!CardViewComponent) {
        continue;
      }
      const cardViewId = c.cardViewId;
      const isLocked = c.isLocked;
      const reducerSubName = c.reducerSubName;
      results.push(
        <div className="myprivileges-card-list-item" key={cardViewId}>
          <CardViewComponent
            cardViewId={cardViewId}
            isLocked={isLocked}
            reducerSubName={reducerSubName}
          />
        </div>,
      );
    }
    return results.length > 0 ? results : null;
  }

  renderDetailsView(myPrivilegesId: string, cardViewId: string) {
    const registries = this.get();
    if (!registries[cardViewId]) {
      return null;
    }
    const DetailsViewComponent: any =
      registries[cardViewId].detailsViewComponent;
    const isLocked = registries[cardViewId].isLocked;
    const reducerSubName = registries[cardViewId].reducerSubName;
    const detailClass = registries[cardViewId].detailClass;
    const result = (
      <div className={`privileges-details-view-wrapper ${detailClass}`}>
        <DetailsViewComponent
          myPrivilegesId={myPrivilegesId}
          cardViewId={cardViewId}
          isLocked={isLocked}
          reducerSubName={reducerSubName}
        />
      </div>
    );
    return result ? result : null;
  }
}

export default new MyPrivilegesCardViewRegistry();
